export default "__VITE_ASSET__5a216458__"